import { formatDateString } from "@cp/toolkit";
import type { BankanQuoteColumnQuery } from "@qw/graphql";
import { BankanCard } from "./bankan-card";

type Group = BankanQuoteColumnQuery["bankanQuoteColumn"]["groupedQuotes"][number];

export const BankanCardQuotes = ({
  insured,
  quotes,
  slice = 1,
}: {
  insured: Group["insured"];
  quotes: Group["quotes"];
  slice?: number;
}) => {
  const items = quotes.slice(0, slice);
  const remaining = Math.max(quotes.length - slice, 0);
  return (
    <BankanCard id={insured.id} name={insured.name} remaining={remaining}>
      {items.map((quote) => (
        <div key={quote.id} className="bg-card px-3 py-2 first-of-type:rounded-t last-of-type:rounded-b space-y-1">
          <div className="font-medium text-xs truncate">{quote.appetiteProduct.carrierName}</div>
          <div className="text-xs truncate">{quote.appetiteProduct.carrierProductName}</div>
          <div className="text-2xs text-muted-foreground">{formatDateString(quote.effectiveDate)}</div>
        </div>
      ))}
    </BankanCard>
  );
};
